import type { SVGProps } from 'react'
const SvgAddLocationAlt = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="add-location-alt_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#add-location-alt_svg__a)">
      <path d="M9 16.652q-3.09-2.613-4.621-4.828Q2.848 9.61 2.848 7.633q0-2.873 1.855-4.58Q6.559 1.349 9 1.349q.183 0 .368.002.186.002.369.035V3.11a2.5 2.5 0 0 0-.36-.047A7 7 0 0 0 9 3.053q-1.87 0-3.159 1.284Q4.554 5.62 4.554 7.632q0 1.376 1.095 3.034Q6.744 12.322 9 14.39q2.216-2.028 3.306-3.663t1.131-2.975V7.64h1.71v.114q-.04 1.942-1.568 4.132-1.53 2.19-4.579 4.767m0-7.607q.641 0 1.093-.452t.452-1.093-.452-1.093A1.5 1.5 0 0 0 9 5.955q-.641 0-1.093.452A1.5 1.5 0 0 0 7.455 7.5q0 .641.452 1.093T9 9.045m4.486-2.906h1.64v-2.25h2.25V2.25h-2.25V0h-1.64v2.25h-2.25v1.639h2.25z" />
    </g>
  </svg>
)
export default SvgAddLocationAlt
